import * as Yup from 'yup';

const validationSchema = () => {
  return Yup.object({
    date: Yup.string().required('tracker.logMeal.input.validationError.empty'),
    time: Yup.string().required('tracker.logMeal.input.validationError.empty'),
    burnedCalories: Yup.number()
      .integer('tracker.validationError.accetableValue')
      .min(1, 'tracker.validationError.accetableValue')
      .max(5000, 'tracker.validationError.accetableValue')
      .required('tracker.logMeal.input.validationError.empty'),
    duration: Yup.number()
      .integer('tracker.validationError.accetableValue.duration')
      .min(1, 'tracker.validationError.accetableValue.duration')
      .max(720, 'tracker.validationError.accetableValue.duration')
      .required('tracker.logMeal.input.validationError.empty'),
    distance: Yup.number()
      .nullable()
      .test('distance-validation', function (value) {
        // If distance is null or undefined, it's optional - validation passes
        if (value === undefined || value === null) {
          return true;
        }

        const { distanceUnit } = this.parent;
        if (distanceUnit === 'm') {
          if (value < 1 || value > 500000) {
            return this.createError({
              message: 'tracker.validationError.accetableValue.meters',
            });
          }
        } else if (distanceUnit === 'km') {
          if (value < 0.1 || value > 500) {
            return this.createError({
              message: 'tracker.validationError.accetableValue.kilometers',
            });
          }
        } else if (distanceUnit === 'mi') {
          if (value < 0.1 || value > 300) {
            return this.createError({
              message: 'tracker.validationError.accetableValue.miles',
            });
          }
        } else if (distanceUnit === 'yd') {
          if (value < 1 || value > 500000) {
            return this.createError({
              message: 'tracker.validationError.accetableValue.yards',
            });
          }
        }
        return true;
      }),
    activityName: Yup.string().required('tracker.logMeal.input.validationError.empty'),
  });
};

export default validationSchema;
